import Model from './Model';

export default class User extends Model {
  // eslint-disable-next-line
  resource() {
    return 'users';
  }
}



// WEBPACK FOOTER //
// ./src/models/User.js